module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-internalError"
  }, _vm._l((_vm.errorPage), function(errors) {
    return _c('section', {
      directives: [{
        name: "in-viewport",
        rawName: "v-in-viewport"
      }],
      staticClass: "container-fluid"
    }, [_c('div', {
      staticClass: "text-center headline-container"
    }, [_c('h1', {
      directives: [{
        name: "in-viewport",
        rawName: "v-in-viewport"
      }],
      staticClass: "headline"
    }, [_vm._v(_vm._s(errors.elements.n500.value) + " ")])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9cf2142","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/InternalError.vue
// module id = 1556
// module chunks = 0